module.exports = __webpack_public_path__ + "img/member_conpany_02.77bc6052.png";